enum ComposeTarget {
    PrimaryReadingPane /* default */,
    SecondaryTab /* Tab */,
    Popout /* Popout */,
    SxS /* SxS */,
}

export default ComposeTarget;
